import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../redux/index';
import { useNavigate } from 'react-router-dom';
import { TableCell } from '@mui/material';

const SubCompanySearchRow = ({row, count, tableHeader,selectableRows}) => {
    // redux state for use of persistant state in different route (CompanyDetailsPage)
    const company = useSelector((state) => state.company);
    const companyInfo = useSelector((state) => state.companyInfo);
    const backPath = useSelector((state) => state.backPath); 
    const dispatch = useDispatch();
    const { setCompany, setCompanyInfo, setBackPath } = bindActionCreators(actionCreators, dispatch);
    const navigate = useNavigate();

    const onRowClick = () =>{
        //event handler when anywhere in the row is clicked
        if(selectableRows){
            // set back path to let navbar on next page to return to /SubCompanySearchPage
            setBackPath('/SubCompanySearchPage'); 
            // set company state to bring to new route
            setCompany(row['mastercompanyname']);
            setCompanyInfo(row);
            navigate("/CompanyDetailsPage");
        }
    }


    return(
        <>
            {tableHeader.map(el => {
                // logic to determine how to display each column based on name
                if ( el['columnname'] == 'companyname'){
                    return(
                        <TableCell onClick={()=>onRowClick()} className= {selectableRows ? 'table-cell-clicky' :''}>
                            <div className='table-cell-link-row'>
                                {row[el['columnname']]}
                            </div>
                        </TableCell>
                    );
                }
                else if (row[el['columnname']] == null){
                    return(
                        <TableCell onClick={()=>onRowClick()} className= {selectableRows ? 'table-cell-clicky' :''}>None</TableCell>
                    );
                }
                else{
                    return(
                        <TableCell onClick={()=>onRowClick()} className= {selectableRows ? 'table-cell-clicky' :''}>{row[el['columnname']]}</TableCell>
                    );
                }
            })}
        </>
    );
}

export default SubCompanySearchRow; 